import * as Label from '@radix-ui/react-label'
import { forwardRef, useId } from 'react'
import { cx } from '../util/cx'
import styles from './TextField.module.css'

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
  endAdornment?: React.ReactNode
}

const TextField = forwardRef<HTMLInputElement, TextFieldProps>(function TextField(
  { label, error, endAdornment, className, id, ...inputProps },
  ref,
) {
  const generatedId = useId()
  const inputId = id ?? generatedId
  const errorId = error ? `${inputId}-error` : undefined

  return (
    <div className={styles.field}>
      <Label.Root htmlFor={inputId} className={styles.label}>
        {label}
      </Label.Root>
      <div className={styles.inputWrap}>
        <input
          ref={ref}
          id={inputId}
          className={cx(styles.input, error && styles.inputError, className)}
          aria-invalid={error ? true : undefined}
          aria-describedby={errorId}
          {...inputProps}
        />
        {endAdornment}
      </div>
      {error && (
        <span id={errorId} className={styles.error} role='alert'>
          {error}
        </span>
      )}
    </div>
  )
})

export default TextField
